import { lazy } from 'react';

const ProductGroup = lazy(() => import('./ProductGroup'));

export default ProductGroup;
